import { Company } from '../services/company.service';

/** Initials for company logo fallback (1–2 characters). */
export function companyInitials(name: string): string {
  const parts = (name || '').trim().split(/\s+/).filter(Boolean);
  if (!parts.length) {
    return '?';
  }
  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }
  return `${parts[0][0] || ''}${parts[1][0] || ''}`.toUpperCase();
}

/** Tracks logo URLs that failed to load so templates can fall back to initials. */
export class FailedLogoTracker {
  private failed: Record<string, true> = {};

  url(company: Company | null | undefined): string | null {
    const logo = (company?.logo || '').trim();
    if (!logo || this.failed[logo]) {
      return null;
    }
    return logo;
  }

  markFailed(company: Company | null | undefined): void {
    const logo = (company?.logo || '').trim();
    if (logo) {
      this.failed = { ...this.failed, [logo]: true };
    }
  }
}
